import React, { useState, useEffect, useRef } from 'react';
import { MDBDataTable } from 'mdbreact';
import { Form } from 'react-bootstrap';
import { Button, Container, IconButton } from '@mui/material';
import Select from "react-select";
import { baseURL } from '../base_url';
import axios from 'axios';
import moment from 'moment';
// import AlertMaps from './AlertMaps';
import { PuffLoader } from 'react-spinners';
import { read, utils, writeFile } from 'xlsx';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import TextField from '@mui/material/TextField';
import Swal from 'sweetalert2';
import { FaUpload } from "react-icons/fa";
import dayjs from 'dayjs';
import { FaDownload } from 'react-icons/fa';


const chargeTypeLabels = {
  'charge_at_counter': 'Charged At Counter',
  'penalty_imposed': 'Penalty Imposed',
  'pending': 'Pending',
  'one_way': 'One-Way Rental',
  'corporate': 'Corporate',
  'governemnt_reservation': 'Government Reservation',
  'wrong_alert': 'Wrong Alert',
};

function formatLocationDate(locationDateTime) {
  const parsedDate = dayjs(locationDateTime, 'YYYY-MM-DD HH:mm:ss A');
  return parsedDate.format('MM/DD/YYYY hh:mm A');
}

const Alerts = () => {
  const [accessDetails, setAccessDetails] = useState([]);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [geofenceCoordinates, setGeofenceCoordinates] = useState([])
  const [selectedVehicleInfo, setSelectedVehicleInfo] = useState('');
  const [loading, setLoading] = useState(false);
  const [exportTableData, setExportTableData] = useState([]);
  const [checkedItems, setCheckedItems] = useState([]);
  const [locationItems, setLocationItems] = useState([])
  const [selectedLocation, setSelectedLocation] = useState({ label: "All", value: "0" })
  const [selectedStatus, setSelectedStatus] = useState({ label: "All", value: "0" })
  const [selectedChargeType, setSelectedChargeType] = useState({ label: "All", value: "0" })
  const [userItems, setUserItems] = useState([])
  const [selectedUser, setSelectedUser] = useState({ label: "All", value: "0" })
  const [selectedApi, setSelectedApi] = useState({ label: "All", value: "0" })
  const [excelUploadCount, setExcelUploadCount] = useState('')


  const loggedInUser = sessionStorage.getItem("tm_token");
  const foundUser = JSON.parse(loggedInUser);
  const [selectedFromDate, setSelectedFromDate] = useState(new Date(new Date().setDate(new Date().getDate() - 2)));
  const [selectedToDate, setSelectedToDate] = useState(new Date());

    const handleCheckboxChange = (event, val) => {
      let checked_val = event.target.checked
      setLoading(true);
      axios.get(baseURL + "/tagged_tsd_update?val_id="+val+"&checked_val="+checked_val).then((res) => {
          setCheckedItems({ ...checkedItems, [val]: checked_val });
          setLoading(false);
      })
    };
    useEffect(() => {
      alertData();
    },[]);
    
    useEffect(() => {
      axios.get(baseURL + "/get_location_setup?status=active&admin_id=" + foundUser['tm_id']).then((res) => {
        const allOption = { label: "All", value: "0" };
        const menuList2 = res.data.data.map((val1) => {
          return { label: val1.location_name, value: val1._id }
        })
        setLocationItems([allOption, ...menuList2])
      });

      axios.get(baseURL + "/get_all_users?status=active").then((res) => {
        const allOption = { label: "All", value: "0" };
        const menuList2 = res.data.map((val1) => {
          return { label: val1.user_name, value: val1.id }
        })
        setUserItems([allOption, ...menuList2])
      });
    },[]);

    const statusItems = [
        { value: '0', label: 'All' },
        { value: 'Open', label: 'Open' },
        { value: 'Closed', label: 'Closed' },
        { value: 'Processing', label: 'Processing' }
    ];

    const apiItems = [
        { value: '0', label: 'All' },
        { value: 'stellantis', label: 'Stellantis' },
        { value: 'ford', label: 'Ford' },
        { value: 'vw', label: 'Volkswagon' },
        { value: 'ridesiq', label: 'RidesIQ' },
        { value: 'nissan', label: 'Nissan' }
    ];

    const handleApiChange = (selectedOption) => {
      setSelectedApi(apiItems.find(option => option.value === selectedOption.value))
      return false;
    }

    const handleStatusChange = (selectedOption) => {
      setSelectedStatus(statusItems.find(option => option.value === selectedOption.value))
      return false;
    }

    const chargeTypeItems = [
        { value: '0', label: 'All' },
        { value: 'charge_at_counter', label: 'Charged At Counter' },
        { value: 'penalty_imposed', label: 'Penalty Imposed' },
        { value: 'pending', label: 'Pending' },
        { value: 'one_way', label: 'One-Way Rental' },
        { value: 'corporate', label: 'Corporate'},
        { value: 'governemnt_reservation', label: 'Government Reservation'},
        { value: 'wrong_alert', label: 'Wrong Alert' }
    ];

    const handleChargeTypeChange = (selectedOption) => {
      setSelectedChargeType(chargeTypeItems.find(option => option.value === selectedOption.value))
      return false;
    }
    
    const handleLocationChange = (selectedOption) =>{
        setSelectedLocation(locationItems.find(option => option.value === selectedOption.value))
        return false;
    }

    const handleUserChange = (selectedOption) => {
      setSelectedUser(userItems.find(option => option.value === selectedOption.value))
      return false;
    }

    

    const alertData = () => {
      const fromDate = new Date(selectedFromDate).toDateString()
      const toDate = new Date(selectedToDate).toDateString()
      setLoading(true);
      axios.get(baseURL + "/get_alert_warning?total=all&from="+fromDate+"&to="+toDate+"&location="+selectedLocation.value+"&status="+selectedStatus.value+"&charge_type="+selectedChargeType.value+"&api_type="+selectedApi.value+"&admin_id=" + selectedUser.value).then((res) => {
          var j = 1;
          setLoading(false);
          if(res.data.status === '1'){
              let rowsData = [];
              let ExportTableData = [];
              const myDataSet = res.data.data;
              for (var index = 0; index < res.data.data.length; index++) {
                  let rowItem = {};
                  const val = myDataSet[index];
                  let updated_datetime = ''
                  // if(val.tagged_tsd === 'false'){
                  //   val.tagged_tsd = false;
                  // }
                  // if (typeof val.tagged_tsd === 'string') {
                  //   val.tagged_tsd = val.tagged_tsd.toLowerCase() === 'true';
                  // }
                  rowItem["id"] = j;
                  // rowItem['tagged_tsd'] = <div className='d-flex justify-content-center'><Form.Check className='' type="checkbox" checked={checkedItems[val.id] || (val.tagged_tsd || false)} onChange={(e) => handleCheckboxChange(e,val.id)} /></div>
                  rowItem["vin"] = val.vin;
                  rowItem["location"] = val.loc_name;
                  rowItem["agreement_status"] = val.agreement_status;
                  rowItem["agreement_number"] = val.agreement_number;
                  if(val.return_date != '')
                  {
                    rowItem["return_date"] = moment(val.return_date).format('MM/DD/YYYY');
                  }
                  rowItem["alert_from"] = val.alert_from;
                  if(val.type === "border_cross"){
                      rowItem["details"] = <div>the out of <b>State Border</b> at coordinates:(lat: {val.latitude},lng: {val.longitude}).<br/></div> ;
                      rowItem["details2"] = "the out of State Border at coordinates:(lat: "+val.latitude+",lng: "+val.longitude+")";
                      rowItem["location_details"] = (val.location_info)?val.location_info:"";
                  }else{
                      rowItem["details"] = val.response_data;
                      rowItem["details2"] = val.response_data;
                      rowItem['location_details'] = "";
                  }
                  rowItem['charge_status'] = val.charge_status;
                  rowItem['charge_option'] = chargeTypeLabels[val.charge_option] || val.charge_option; // Map charge_option to label
                  rowItem['charge_total'] = parseFloat(val.charge_total).toFixed(2);
                  rowItem['comment'] = val.comment
                  rowItem['updated_by'] = val.added_by
                  // rowItem['c_date'] = moment(new Date(val.datetime)).tz("US/Eastern").format('MM/DD/YYYY hh:mm A');
                  rowItem['c_date'] = formatLocationDate(val.location_datetime_c);
                  if(val.updated_datetime)
                  {
                    updated_datetime = moment(new Date(val.updated_datetime)).tz("US/Eastern").format('MM/DD/YYYY hh:mm A');
                  }
                  rowItem['action'] = ((val.type === "border_cross")?<Button size='small' onClick={(e) => handleLogDetails(val.id,val)} variant="contained">Details</Button>:"");
                  ExportTableData.push([j, val.vin, val.loc_name, val.agreement_status, val.agreement_number, rowItem["return_date"] , val.alert_from ,rowItem["details2"],rowItem["location_details"],rowItem['charge_status'] ,rowItem['charge_option'],rowItem['charge_total'],val.comment,val.added_by,rowItem['c_date'],updated_datetime]);
                  rowsData.push(rowItem)
                  j++;
              }
              setExportTableData(ExportTableData)
              setAccessDetails(rowsData);
          }else{
              setAccessDetails([]);
          }
      });
    }
    const submitDate = () => {
      alertData();
    }
    const data = {
        columns: [
          {
            label: 'S.No',
            field: 'id',
          },
          // {
          //   label: 'Tagged TSD',
          //   field: 'tagged_tsd',
          // },
          {
            label: 'VIN',
            field: 'vin',
          },
          {
            label: 'Location',
            field: 'location',
          },
          {
            label: 'Agreement Status',
            field: 'agreement_status',
          },
          {
            label: 'Agreement Number',
            field: 'agreement_number',
          },
          {
            label: 'Return Date',
            field: 'return_date',
          },
          {
            label: 'Alert From',
            field: 'alert_from',
          },
          // {
          //   label: 'Details',
          //   field: 'details',
          // },
          // {
          //   label: 'Location Details',
          //   field: 'location_details',
          // },
          {
            label: 'Status',
            field: 'charge_status',
          },
          {
            label: 'Charge Type',
            field: 'charge_option',
          },
          {
            label: 'Charged Total',
            field: 'charge_total',
          },
          {
            label: 'Comment',
            field: 'comment',
          },
          {
            label: 'Updated By',
            field: 'updated_by',
          },
          {
            label: 'Location DateTime',
            field: 'c_date',
          },
          {
            label: 'Action',
            field: 'action',
          },
        ],
        rows: accessDetails
    };
    const handleExportTableData = () => {
      const headings = [['S.No','VIN Number','Location','Agreement Status','Agreement Number','Return Date', 'Alert From','Details',"location_details",'Status','Charge Type','Charged Amount','Comment','Added By','Created datetime','Updated Datetime']];
      const sampleVin = exportTableData;
      const wb = utils.book_new();
      const ws = utils.json_to_sheet([]);
      utils.sheet_add_aoa(ws, headings);
      utils.sheet_add_json(ws, sampleVin, { origin: 'A2', skipHeader: true });
      utils.book_append_sheet(wb, ws, 'BCF Alerts');
      writeFile(wb, 'BCF Alerts.xlsx');
    }
    // const handleLogDetails = (value,details) =>{
    //     setLoading(true);
    //     axios.get(baseURL + "/get_geofence_state?loc_id="+details.loc_id+"&admin_id=" + foundUser['tm_id']).then((res) => {
    //         setGeofenceCoordinates(res.data)
    //         setDetailsOpen(true)
    //     });
    //     setSelectedVehicleInfo({"lat":details.latitude,"lng":details.longitude,"data":details});
    // }    
    const handleLogDetails = (value, details) => {
      window.open('/alert_maps?id=' + JSON.stringify(value), '_blank');
    };

    const fileInputRef = useRef(null);

    const handleImport_old = async ($event) =>
    {
      const files = $event.target.files;
      if (files.length) {
        const file = files[0];
        const reader = new FileReader();
        reader.onload = async (event) => {
        const wb = read(event.target.result);
        const sheets = wb.SheetNames;
        if (sheets.length) {
          const rows = utils.sheet_to_json(wb.Sheets[sheets[0]], { header: 1, defval: "" });
          // if (rows[0].includes("VIN") && rows[0].includes("Agreement Number") && rows[0].includes("Agent") && rows[0].includes("Charge Option") && rows[0].includes("Amount") && rows[0].includes("Pickup Date")) {
          if (rows[0].includes("R/A Number") && rows[0].includes("Drop Off Date")  && rows[0].includes("Assigned Unit VIN")) {
            const data = utils.sheet_to_json(wb.Sheets[sheets[0]]);
            if (data.length > 4000) {
              Swal.fire({
                icon: 'error',
                text: "Oops! Your file size is " + data.length + ", but the maximum allowed size is 4000. Please reduce your file size and try again."
              })
              return false;
            }
            if (data.length > 0) {
              setLoading(true);
              let id_v = 0;
              // Process each item with a concurrency limit of 3
              const concurrencyLimit = 1;
              let activeRequests = 0;
              const queue = [];
              const processQueue = async () => {
                while (activeRequests < concurrencyLimit && queue.length) {
                  const item = queue.shift();
                  activeRequests++;
                  try {
                    await axios.post(baseURL + "/update_return_date", {
                      'data': JSON.stringify(item), 
                      'admin_id': foundUser['tm_id'],
                      // 'from_date': selectedFromDate,
                      // 'to_date':selectedToDate
                    });
                    id_v += 1;
                  } catch (error) {
                    console.error('Error uploading item:', error);
                    Swal.fire({
                      icon: 'error',
                      text: 'Failed to upload some items.'
                    });
                    return;
                  } finally {
                    activeRequests--;
                    processQueue(); // Trigger the next request in the queue
                  }
                  if (data.length === id_v) {
                    setLoading(false);
                    Swal.fire({
                      icon: 'success',
                      text: "Pickup Date updated successfully."
                    }).then(() => {
                      // window.location.reload();
                    });
                  }
                }
              };
                for (const item of data) {
                queue.push(item);
              }
              processQueue();
            } else {
              Swal.fire({
                icon: 'error',
                text: 'You have uploaded an empty file.'
              })
              return;
            }
          } else {
            Swal.fire({
              icon: 'error',
              text: 'You have uploaded an invalid file. Please download the sample template for your reference.'
            })
            return;
          }
        }
      }
      reader.readAsArrayBuffer(file);
    }
    fileInputRef.current.value = '';
    }

    const handleImport = async ($event) => {
      const files = $event.target.files;
      if (files.length) {
          const file = files[0];
          const formData = new FormData();
          formData.append('file', file);
          formData.append('admin_id', foundUser['tm_id']);

          const reader = new FileReader();
          reader.onload = async (event) => {
              const wb = read(event.target.result);
              const sheets = wb.SheetNames;
              if (sheets.length) {
                  const rows = utils.sheet_to_json(wb.Sheets[sheets[0]], { header: 1, defval: "" });
                  if (rows[0].includes("R/A Number") && rows[0].includes("Drop Off Date")  && rows[0].includes("Assigned Unit VIN")) {
                      const data = utils.sheet_to_json(wb.Sheets[sheets[0]]);
                      if (data.length > 4000) {
                          setLoading(false);
                          Swal.fire({
                              icon: 'error',
                              text: "Oops! Your file size is " + data.length + ", but the maximum allowed size is 4000. Please reduce your file size and try again."
                          });
                          return false;
                      }
                      if (data.length > 0) {
                          setLoading(true);
                          setExcelUploadCount('Uploading...');
                          try {
                              // Send the entire dataset at once
                              await axios.post(baseURL + "/update_return_date", {
                                  data: JSON.stringify(data),
                                  admin_id: foundUser['tm_id']
                              });

                              setExcelUploadCount('');
                              Swal.fire({
                                  icon: 'success',
                                  text: "Return Date Updated successfully."
                              }).then(() => {
                                  window.location.reload();
                              });
                          } catch (error) {
                              console.error('Error uploading data:', error);
                              Swal.fire({
                                  icon: 'error',
                                  text: 'Failed to upload data.'
                              });
                          } finally {
                              setLoading(false);
                          }
                      } else {
                          Swal.fire({
                              icon: 'error',
                              text: 'You have uploaded an empty file.'
                          });
                          return;
                      }
                  } else {
                      Swal.fire({
                          icon: 'error',
                          text: 'You have uploaded an invalid file. Please download the sample template for your reference.'
                      });
                      return;
                  }
              }
          };
          reader.readAsArrayBuffer(file);
      }
      fileInputRef.current.value = '';
    };

    const handleDownloadTemplate = () => {
      const headings = [['R/A Number','Drop Off Date','Assigned Unit VIN']];
      const sampleVin = [['ORD-160712','07-01-2024 12:46 AM','1C4PJXEN2RW179533'],['ORD-160715','07-01-2024 01:40 AM','1C4PJXEN0RW179529']];
      const wb = utils.book_new();
      const ws = utils.json_to_sheet([]);
      utils.sheet_add_aoa(ws, headings);
      utils.sheet_add_json(ws, sampleVin, { origin: 'A2', skipHeader: true });
      ws['!cols'] = [{ width: 20 }];
      utils.book_append_sheet(wb, ws, 'Return Date Sample');
      writeFile(wb, 'Return Date Sample.xlsx');
    }

    return (
    <div className='body_class' style={{marginLeft:"13vw",paddingLeft:"20px",paddingRight:"20px"}}>
      
      {loading ? (
                <div className="loader-overlay">
                    <div className="loader">
                        <div className='excel-upload-count'>{excelUploadCount}</div>
                        <PuffLoader color="#00308F" loading={true} size={200} />
                    </div>
                </div>
            ) : ("")}
        {/* <Container> */}
            <h5>Alerts/Warnings</h5>
            <div className='row p-4'>
              <div className="col-auto mt-1">
                <label htmlFor="datepicker" className="form-label">Start Date:</label>
              </div>
              <div className='col-2'>
                <DatePicker
                  id="datepicker"
                  selected={selectedFromDate}
                  onChange={(date) => setSelectedFromDate(date)}
                  className="form-control" // Bootstrap class for input fields
                />
              </div>
              <div className="col-auto mt-1">
                <label htmlFor="datepicker" className="form-label">To Date:</label>
              </div>
              <div className='col-2'>
                <DatePicker
                  id="datepicker"
                  selected={selectedToDate}
                  onChange={(date) => setSelectedToDate(date)}
                  className="form-control" // Bootstrap class for input fields
                />
              </div>
              <div className="col-auto mt-1">
                <label htmlFor="Location" className="form-label">Location:</label>
              </div>
              <div className='col-2'>
                <Select placeholder="Select Location" options={locationItems} onChange={handleLocationChange} value={selectedLocation}/>
              </div>
              <div className="col-auto mt-1">
                <label htmlFor="Status" className="form-label">Status:</label>
              </div>
              <div className='col-2'>
                <Select placeholder="Select Status" options={statusItems} onChange={handleStatusChange} value={selectedStatus}/>
              </div>
            </div>
            <div className='row' style={{marginLeft:"14px"}}>
                <div className="col-auto mt-1">
                  <label htmlFor="Status" className="form-label">Charge Type:</label>
                </div>
                <div className='col-3'> 
                  <Select placeholder="Select Status" options={chargeTypeItems} onChange={handleChargeTypeChange} value={selectedChargeType}/>
                </div>
                <div className="col-auto mt-1">
                  <label htmlFor="Status" className="form-label">Updated By:</label>
                </div>
                <div className='col-2'> 
                  <Select placeholder="Select User" options={userItems} onChange={handleUserChange} value={selectedUser}/>
                </div>
                <div className="col-auto mt-1">
                  <label htmlFor="Status" className="form-label">API:</label>
                </div>
                <div className='col-2'> 
                  <Select placeholder="Select User" options={apiItems} onChange={handleApiChange} value={selectedApi}/>
                </div>
                <div className='col-1'>
                  <Button variant="contained" onClick={submitDate} >Submit</Button>
                </div>
              </div>
              <div className='row' style={{marginLeft:"14px",marginTop:"10px"}}>
                <div className='col-auto mt-1'>
                  <input
                    type="file"
                    id="select-csv"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    style={{ display: 'none' }}
                    multiple={false}
                    required
                    onChange={handleImport}
                    ref={fileInputRef}
                  />
                  <label htmlFor="select-csv">
                      <Button size='large' variant="contained" className="btn btn-primary" component="span">
                        <FaUpload size={14}/>&nbsp;Update Return Date
                      </Button>
                      
                  </label>
                </div>
                <div className='col-auto mt-1'>
                  <Button size="large" style={{marginLeft:"2rem"}} type="submit" variant="contained" onClick={handleDownloadTemplate}>
                    <FaDownload size={18}/>&nbsp;Download Template
                  </Button>
                </div>
            </div>
            <br></br>
            <div style={{ position: "absolute", marginTop:"-5px", padding:"7px"}}><Button size='small' variant="contained" onClick={handleExportTableData}>Export Excel</Button></div>
            <div className="row mt-1">
                {!detailsOpen &&
                <div className="col-md-12">
                    <MDBDataTable
                        bordered
                        data={data}
                        large={false}
                        displayEntries={false}
                        search={true}
                        noBottomColumns={true}
                        className="pagination-right-aligned"
                        searching={true}
                    />
                </div>}
                {/* {detailsOpen &&
                    <>
                    <div className='alert_back'><Button size='small' onClick={(e) => setDetailsOpen(false)} variant="contained">back</Button></div>
                    <AlertMaps geofenceCoordinates={geofenceCoordinates} selectedVehicle={selectedVehicleInfo}/>
                    </>
                } */}
            </div>
        {/* </Container> */}
    </div>
    );
};

export default Alerts;
